import { useEffect, useState } from "react";
import { showToast } from "../../utils/toast";
import { getRequest, postRequest } from "../../utils/api";
import Loader from "../../Component/Loader/Loader";
import Swal from "sweetalert2";
import { logout } from "../../utils/auth";
import { toast } from "react-toastify";
import moment from "moment";
const CommissionTier = () => {
    const [loading, setLoading] = useState(false);

    // Main Plan Data State
    const [formData, setFormData] = useState({
        _id: "",
        commission_id: "",
        commission_title: "",
        commission_amount: "",
        commission_publish_type: 0,
    });

    const handlePublish = async () => {
        if (!formData.commission_title) {
            showToast.error("Title is required.");
            return;
        }

        setLoading(true);

        try {
            const payload = {
                _id: formData._id,
                commission_id: formData.commission_id,
                commission_title: formData.commission_title,
                commission_amount: formData.commission_amount,
                commission_publish_type: formData.commission_publish_type,
            }
            const res = await postRequest("/affiliate/add-commission-tier", payload);

            if (res.status === "success") {
                fetchCommissionTierList()
                setFormData({
                    _id: "",
                    commission_id: "",
                    commission_title: "",
                    commission_amount: "",
                    commission_publish_type: 0,
                });
                showToast.success(res.message);
            } else {
                showToast.error(res.message);
            }
        } catch (error: any) {
            showToast.error(error.message || "An error occurred.");
        } finally {
            setLoading(false);
        }
    };

    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    useEffect(() => {
        fetchCommissionTierList()
    }, []);

    const [commissionList, setKnowledgeCategoryArtical] = useState<any[]>([]);
    const [isLoader, setIsLoader] = useState<any>(false);
    const fetchCommissionTierList = async () => {
        setLoading(true);
        try {
            const response = await getRequest(`/affiliate/commission-list`);

            if (response.status === "success") {
                setKnowledgeCategoryArtical(response.data);
            } else if (response.status == 'session_expired') {
                setLoading(false)
                logout()
            }
            else {
                setLoading(false)
                toast.error(response.message);
            }
        } catch (error) {
            console.error("Error fetching plans:", error);
        } finally {
            setLoading(false);
        }
    };

    const editUser = (item: any) => {
        setFormData({
            _id: item._id,
            commission_id: item.commission_id,
            commission_title: item.commission_title,
            commission_amount: item.commission_amount,
            commission_publish_type: item.commission_publish_type,
        });
    }

    const deleteCommissionTier = async (item: any) => {
        const result = await Swal.fire({
            title: 'Are you sure want to permanent delete?',
            showConfirmButton: true,
            showCancelButton: true,
            confirmButtonText: "OK",
            cancelButtonText: "Cancel",
            icon: 'warning',
            customClass: {
                title: "custom-swal-title",
                popup: "custom-swal-popup",
                confirmButton: "custom-swal-button",
                cancelButton: "custom-swal-cancel"
            }
        });

        if (result.isConfirmed) {
            setIsLoader(true);
            try {
                const payload = {
                    _id: item?._id,
                };
                const response = await postRequest('/affiliate/deleteCommissionTier', payload);
                if (response.status === 'success') {
                    setFormData({
                        _id: "",
                        commission_id: "",
                        commission_title: "",
                        commission_amount: "",
                        commission_publish_type: 0,
                    });
                    fetchCommissionTierList();
                    Swal.fire({
                        title: response.message,
                        icon: 'success',
                        customClass: {
                            popup: "custom-swal-popup"
                        }
                    });
                } else if (response.status === 'session_expired') {
                    setIsLoader(false);
                    logout()
                } else {
                    setIsLoader(false);
                    Swal.fire({
                        title: response.message,
                        icon: 'error',
                        customClass: {
                            popup: "custom-swal-popup"
                        }
                    });
                }
            } catch (error: any) {
                setIsLoader(false);
                toast.error(error.message);
            } finally {
                setIsLoader(false);
            }
        }
    };

    return (
        <>
            {isLoader || loading && (<Loader />)}
            <div className="hk-pg-wrapper">
                <div className="hk-pg-body py-0">
                    <div className="page-wrap">
                        <div className="page-content ps-0">
                            <div className="page-detail-wrap">
                                <header className="page-header">
                                    <div>
                                        <div className="page-title">
                                            <h2 className="mb-0">Commission Tier</h2>
                                        </div>
                                        <p className="text-muted mb-0">Manage your Commission Tier</p>
                                    </div>
                                    <div className="page-options-wrap">
                                        <a className="btn btn-icon btn-flush-dark btn-rounded flush-soft-hover hk-navbar-togglable d-lg-inline-block d-none"
                                            href="#" data-bs-toggle="tooltip" data-bs-placement="top" title=""
                                            data-bs-original-title="Collapse">
                                            <span className="btn-icon-wrap">
                                                <span className="feather-icon"><i className="ri-arrow-up-s-line ri-lg"></i></span>
                                                <span className="feather-icon d-none"><i className="ri-arrow-down-s-line ri-lg"></i></span>
                                            </span>
                                        </a>
                                    </div>
                                </header>
                                <div className="page-body">
                                    <div data-simplebar className="nicescroll-bar">
                                        <div className="container-fluid">
                                            <div className="row g-3">
                                                <div className="col-lg-5">
                                                    <div className="card">
                                                        <div className="card-header">
                                                            <h6>Commission Details</h6>
                                                        </div>
                                                        <div className="card-body">
                                                            <div className="row g-3">
                                                                <div className="col-lg-6">
                                                                    <div className="form-group mb-0">
                                                                        <label>Commission Title</label>
                                                                        <input type="text" name="commission_title" value={formData.commission_title} onChange={handleChange} className="form-control" />
                                                                    </div>
                                                                </div>
                                                                <div className="col-lg-6">
                                                                    <div className="form-group mb-0">
                                                                        <label>Percentage</label>
                                                                        <input type="number" name="commission_amount" value={formData.commission_amount} onChange={handleChange} className="form-control" />
                                                                    </div>
                                                                </div>
                                                                <div className="col-lg-12">
                                                                    <div className="d-flex justify-content-between align-items-center">
                                                                        <div className="d-flex align-items-start gap-3">
                                                                            {formData.commission_publish_type === 1 ?
                                                                                <i className="ri-lock-line fs-5 text-muted mt-1"></i>
                                                                                : <i className="ri-lock-unlock-line fs-5 text-muted mt-1"></i>
                                                                            }
                                                                            <div>
                                                                                <div className="fw-semibold">
                                                                                    Default
                                                                                </div>
                                                                                <div className="text-muted small">
                                                                                    Default Commission for new Affiliate
                                                                                </div>
                                                                            </div>
                                                                        </div>

                                                                        <div className="form-check form-switch">
                                                                            <input
                                                                                className="form-check-input"
                                                                                type="checkbox"
                                                                                role="switch"
                                                                                checked={formData.commission_publish_type === 1}
                                                                                onChange={(e) =>
                                                                                    setFormData(prev => ({
                                                                                        ...prev,
                                                                                        commission_publish_type: e.target.checked ? 1 : 0
                                                                                    }))
                                                                                }
                                                                            />
                                                                        </div>

                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="card-footer">
                                                            <button
                                                                type="button"
                                                                className="btn btn-primary"
                                                                onClick={handlePublish}
                                                                disabled={loading}
                                                            >
                                                                {loading ? 'Saving...' : 'Save'}
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-lg-7">
                                                    <div className="card">
                                                        <div className="table-responsive">
                                                            <table className="table table-hover mb-0">
                                                                <thead>
                                                                    <tr>
                                                                        <th>Title</th>
                                                                        <th className="text-center">Percentage</th>
                                                                        <th className="text-center">Default</th>
                                                                        <th>Create Date</th>
                                                                        <th className="text-center">Action</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {commissionList.length > 0 ? (
                                                                        commissionList.map((item) => (
                                                                            <tr key={item._id}>
                                                                                <td>{item.commission_title}</td>
                                                                                <td className="text-center">{item.commission_amount}%</td> 
                                                                                <td className="text-center">
                                                                                    {item.commission_publish_type == 1 ?
                                                                                        <i className="ri-check-fill text-success ri-lg"></i>
                                                                                        : "-"
                                                                                    }
                                                                                </td>
                                                                                <td>{moment(item.createdAt).format('DD MMM YYYY')}</td>
                                                                                <td className="text-center">
                                                                                    <div className="d-flex align-items-center justify-content-center gap-1">
                                                                                        <div className="d-flex gap-1">
                                                                                            <a
                                                                                                href="#"
                                                                                                onClick={(e) => { e.preventDefault(); editUser(item) }}
                                                                                                className="btn btn-icon btn-sm btn-flush-dark btn-border flush-soft-hover"
                                                                                                data-bs-toggle="tooltip"
                                                                                                data-placement="top"
                                                                                                title="Edit"
                                                                                            >
                                                                                                <span className="icon">
                                                                                                    <i className="ri-pencil-fill"></i>
                                                                                                </span>
                                                                                            </a>
                                                                                            <a
                                                                                                href="#"
                                                                                                onClick={(e) => { e.preventDefault(); deleteCommissionTier(item) }}
                                                                                                className="btn btn-icon btn-sm btn-flush-dark btn-border flush-soft-hover"
                                                                                                data-bs-toggle="tooltip"
                                                                                                data-placement="top"
                                                                                                title="Edit"
                                                                                            >
                                                                                                <span className="icon">
                                                                                                    <i className="ri-delete-bin-line"></i>
                                                                                                </span>
                                                                                            </a>
                                                                                        </div>
                                                                                    </div>
                                                                                </td>
                                                                            </tr>
                                                                        ))
                                                                    ) : (
                                                                        !loading && (
                                                                            <tr>
                                                                                <td colSpan={8} className="text-center py-4">No artical found.</td>
                                                                            </tr>
                                                                        )
                                                                    )}
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>

    )
}
export default CommissionTier